import { Textarea } from '@chakra-ui/react';
import { FC, useRef, useState } from 'react';
import ResizeTextarea from 'react-textarea-autosize';

import { ACTIONABLE_INTERVENTION_MAX_LENGTH } from '../GoalEditor/consts';
import SmartPhraseInput from '../SmartPhraseInput';
import { ActionableInterventionInputProps } from './types';

const ActionableInterventionInput: FC<ActionableInterventionInputProps> = ({
  setActionableInterventionText,
  value,
}) => {
  const [actionableInterventionIsFocused, setActionableInterventionIsFocused] =
    useState<boolean>(false);
  const actionableInterventionTextareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <>
      {value && (
        <Textarea
          ref={actionableInterventionTextareaRef}
          onChange={(e) => {
            setActionableInterventionText(e.target.value);
          }}
          autoFocus={actionableInterventionIsFocused}
          onFocus={(args) => {
            setActionableInterventionIsFocused(true);
            const cursorPosition = value.length;
            args.target.setSelectionRange(cursorPosition, cursorPosition);
          }}
          onBlur={() => {
            setActionableInterventionIsFocused(false);
          }}
          background={'white'}
          size={'lg'}
          fontSize={'14px'}
          as={ResizeTextarea}
          resize={'none'}
          minRows={1}
          maxRows={10}
          value={value}
          isInvalid={value.length > ACTIONABLE_INTERVENTION_MAX_LENGTH}
          errorBorderColor={'red.500'}
          focusBorderColor="border.brand"
          borderColor={'green.400'}
        />
      )}
      {!value && (
        <SmartPhraseInput
          autoFocus={actionableInterventionIsFocused}
          onFocus={() => {
            setActionableInterventionIsFocused(true);
          }}
          onBlur={() => {
            setActionableInterventionIsFocused(false);
          }}
          setActionableInterventionText={setActionableInterventionText}
          placeholder="Add NCP interventions"
        />
      )}
    </>
  );
};

export default ActionableInterventionInput;
